import {
  AppBar,
  Avatar,
  Box,
  Chip,
  IconButton,
  Toolbar,
  Tooltip,
  Typography,
} from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import { useTheme } from "@mui/material/styles";
import { useAuth } from "../../../contexts/AuthContext";

const SuperAdminHeader = () => {
  const { auth, logout } = useAuth();
  const theme = useTheme();

  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{
        background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.main} 60%, #3a5340 100%)`,
        borderBottom: `3px solid ${theme.palette.tertiary.main}`,
      }}
    >
      <Toolbar
        sx={{
          maxWidth: 1100,
          mx: "auto",
          width: "100%",
          py: 1,
        }}
      >
        <Avatar
          sx={{
            bgcolor: "rgba(255,255,255,0.15)",
            color: theme.palette.secondary.main,
            mr: 2,
            width: 40,
            height: 40,
          }}
        >
          <AdminPanelSettingsIcon />
        </Avatar>

        <Box sx={{ flexGrow: 1 }}>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              color: "white",
              lineHeight: 1.1,
              letterSpacing: 0.2,
            }}
          >
            HoloMenu
          </Typography>
          <Typography
            variant="caption"
            sx={{
              color: theme.palette.secondary.main,
              opacity: 0.85,
              letterSpacing: 1,
              textTransform: "uppercase",
              fontWeight: 600,
            }}
          >
            Super Admin
          </Typography>
        </Box>

        {auth?.user?.email && (
          <Chip
            label={auth.user.email}
            size="small"
            sx={{
              mr: 1,
              color: "white",
              backgroundColor: "rgba(255,255,255,0.12)",
              border: "1px solid rgba(255,255,255,0.2)",
              fontWeight: 500,
              "& .MuiChip-label": { px: 1.5 },
            }}
          />
        )}

        <Tooltip title="Logout">
          <IconButton
            onClick={logout}
            aria-label="Logout"
            sx={{
              color: "white",
              "&:hover": {
                backgroundColor: "rgba(255,255,255,0.12)",
              },
            }}
          >
            <LogoutIcon />
          </IconButton>
        </Tooltip>
      </Toolbar>
    </AppBar>
  );
};

export default SuperAdminHeader;
